import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UserService } from 'app/services/users/user.service';
import { error } from 'protractor';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;

  constructor(private formBuilder: FormBuilder, 
    private userService: UserService,
    private router: Router) { }

  ngOnInit() {
    this.loadForm();
  }

  async login() {
    try {
      const {email, password} = this.loginForm.value;
      if(this.loginForm.status === 'INVALID'){
        console.log('formulario invalido');
      }else{
        let loggedUser = await this.userService.login(email, password);
        if(loggedUser.emailVerified){
          this.router.navigate(['/dashboard']);
        }else{
          this.router.navigate(['/verification']);
        }      
      }
    } catch (error) {
      console.error('Error al iniciar sesion -> ', error)
    }
  }

  loadForm(){
    this.loginForm = this.formBuilder.group({
      email: ['', Validators.required],
      password: ['', Validators.required]
    })
  }
}
